// extracted by mini-css-extract-plugin
module.exports = {"press":"Press_press__3cGZm","img_wrapper":"Press_img_wrapper__1Pq0m","txt":"Press_txt__2CTWW","btn_press":"Press_btn_press__1IZ_r","press_carousel":"Press_press_carousel__4GAwJ"};